import { lazy } from 'react';

export const QuestionsPageLazy = lazy(() => import('./questions'));
